import { 
    View,
    Template
} from "ckeditor5";

import { createApi } from 'unsplash-js';

/**
 * The unsplash form view controller class.
 *
 * See {@link module:unsplash/ui/photoResultView~PhotoResultView}.
 *
 * @extends module:ui/view~View
 */
export default class PhotoResultView extends View {
    constructor(locale, model, config, image) {
        super( locale );

        const imageView = new View( locale );

        const bind = Template.bind(imageView, imageView)

        this.model = model;
        this.config = config;
        this.image = image;

        const accreditationView = this._createAccreditationView();

        imageView.setTemplate({
            tag: 'div',
            attributes: {
                class: 'ck-unsplash-image',
                style: {
                    backgroundImage: `url(${image.urls.small}&fm=jpg&fit=crop&w=160&h=160)`,
                }
            },
            children: [
                accreditationView
            ],
            on: {
                click: bind.to(() => {
                    const model = this.model;
                    const image = this.image;
            
                    model.change(writer => {
                        const imageElement = writer.createElement(
                            'imageBlock',
                            {
                                src: `${image.urls.raw}&fm=jpg&w=800`,
                                alt: `${image?.alt_description ?? ''}`,
                            }
                        )
            
                        const token = this.config.token;
                        const unsplash = createApi({
                            apiUrl: `${this.config.apiUrl}unsplash`,
                            headers: {
                                "authorization": `Bearer ${token}`,
                            }
                        })
            
                        unsplash.photos.trackDownload({
                            downloadLocation: image.links.download_location,
                        });
            
                        model.insertObject(imageElement, model.document.selection);
                    })
                })
            }
        })

        return imageView;
    }

    /**
	 * Creates a unsplash accreditation link view.
	 *
	 * @private
	 * @returns {module:ui/labeledfield/labeledfieldview~LabeledFieldView} anchor tag view instance.
	 */
    _createAccreditationView() {
        const image = this.image;
        const view = new View( this.locale );

        view.setTemplate({
            tag: 'div',
            attributes: {
                class: 'ck-unsplash-image-accreditation',
            },
            children: [
                {
                    tag: 'a',
                    attributes: {
                        rel: 'noreferrer',
                        href: `${image.user.links.html}?utm_source=implement&utm_medium=referral`,
                        target: '_blank',
                    },
                    children: [
                        image.user.name
                    ]
                },
            ]
        })

        return view;
    }

    /**
     * Function to write unsplash image element into document
     */
    _insertUnsplashImage = () => {
        const model = this.model;
        const image = this.image;

        model.change(writer => {
            const imageElement = writer.createElement(
                'imageBlock',
                {
                    src: `${image.urls.raw}&fm=jpg&w=800`,
                    alt: `${image?.alt_description ?? ''}`,
                }
            )

            const token = this.config.token;
            const unsplash = createApi({
                apiUrl: `${this.config.apiUrl}unsplash`,
                headers: {
                    'authorisation': `Bearer ${token}`
                }
            });

            unsplash.photos.trackDownload({
                downloadLocation: image.links.download_location,
            });

            model.insertObject(imageElement, model.document.selection);
        })
    }
}